(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-selector"] && !Shopify.designMode) return;
  try {
    function initLocalization() {
    const form = document.getElementById('localization-form');
    if (!form) return;

    form.querySelectorAll('select').forEach((select) => {
      select.addEventListener('change', () => form.submit());
    });
  }

  document.addEventListener('DOMContentLoaded', initLocalization);
  document.addEventListener('shopify:section:load', initLocalization);
  } catch(e) { console.error(e); }
})();

})();
